import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { startSubmit, stopSubmit } from 'redux-form';

import { getIntl } from '@ackee/jerome/antd';

import message from 'antd/lib/message';

import { push } from 'connected-react-router';

import config from 'config/index';
import { selectors as uploaderSelectors, utils as uploaderUtils } from 'modules/uploader';
import filterUndefined from 'utilities/filterUndefined';
import mergeEmpty from 'utilities/mergeEmpty';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';
import { newsDetailRequest } from '../actions';

const { mapFilesToImages } = uploaderUtils;

const { takeEvery, put, select, take } = sagaEffects;
const { selectUploadedFiles } = uploaderSelectors;

const newsLink = {
    [config.collections.news]: config.routes.newsDetail,
    [config.collections.newsDelayed]: config.routes.newsDelayedDetail,
};

function* handler({ payload, meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    const files = yield select(selectUploadedFiles, 'images');
    const images = mapFilesToImages(files);

    const publish = !payload.delayed || (payload.delayed && !payload.time);

    const collection = publish ? config.collections.news : config.collections.newsDelayed;
    const revCollection = publish ? config.collections.newsDelayed : config.collections.news;

    yield put(startSubmit(meta.form));
    try {
        const commonData = {
            time: publish
                ? firestore.FieldValue.serverTimestamp()
                : firestore.Timestamp.fromDate(new Date(payload.time)),
            tags: payload.tags,
            images,
            youtubeLink: payload.youtubeLink,
            isListed: payload.isListed,
        };

        const filledLanguages = config.app.languages.filter(
            lang => payload[lang] && Object.keys(payload[lang]).length !== 0,
        );
        const firstLanguage = filledLanguages[0];

        const defaultValues = filterUndefined({
            ...payload[firstLanguage],
            ...commonData,
        });

        const batch = firestore.batch();

        let ref = yield firestore.doc(`languages/${config.app.defaultLanguage}/${collection}/${meta.id}`);

        const doc = yield ref.get();
        const exists = doc.exists;

        // If the news doesn't exist, we are immediately publishing already planned news
        // We need to delete it from `newsDelayed` collection and push it to `news` collection

        batch.set(ref, defaultValues);

        for (const lang of filledLanguages.filter(l => l !== firstLanguage)) {
            const data = filterUndefined(mergeEmpty({}, defaultValues, payload[lang]));
            ref = yield firestore.doc(`languages/${lang}/${collection}/${meta.id}`);
            batch.set(ref, data);
        }

        for (const lang of filledLanguages) {
            ref = yield firestore.doc(`languages/${lang}/${revCollection}/${meta.id}`);
            batch.delete(ref);
        }

        yield batch.commit();

        yield put(newsDetailRequest({ id: meta.id, delayed: !publish, silent: true }));
        yield take(types.NEWS_DETAIL_REQUEST_COMPLETED);

        message.success(intl.formatMessage({ id: 'success.news.update' }));
        yield put(stopSubmit(meta.form));

        if (!exists) {
            yield put(push(newsLink[collection].replace(':id', meta.id)));
        }
    } catch (e) {
        yield put(stopSubmit(meta.form, { _error: 'errors.news.update' }));
        loglevel.error(e);
    }
}
export default function* () {
    yield takeEvery(types.UPDATE_NEWS_REQUEST, handler);
}
